$(document).ready(function() {

	// home template scripts
	if ($('body').hasClass('page-template-page-lm-home')) {
		autocomplete();
		initialSearchForm();
	}
	
	// expand/collapse faqs
	$('.lm-faq-question').on('click', function() {
		$(this).parent().toggleClass('lm-faq-active');
	});
	
	// contact form functionality
	$('#subject').change(function() {
		var value = $(this).val();
		if (value === 'Hourly Parking' || value === 'Monthly Parking' || value === 'Refund Request') {
			$('.form-field-facility').show();
		} else {
			$('.form-field-facility').hide();
		}
	});
	
	// contact form submission
	$('#lm-contact-form').validate({
		// debug: true,
		errorElement: 'span',
		errorClass: 'form-field-error',
		validClass: 'form-field-valid',
		errorPlacement: function (error, element) {
			error.appendTo(element.parents('.form-field'));
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
		},
		rules: {
			'name': {
				required: true,
				minlength: 2
			},
			'email': {
				required: true,
				email: true
			},
			'subject': {
				required: true
			},
			'facility': {
				required: function(element) {
					var subject = $('#subject').val();
					if (subject === 'Hourly Parking' || subject === 'Monthly Parking' || subject === 'Refund Request') {
						return true;	
					} else {
						return false;
					}
				}
			},
			'message': {
				required: true,
				minlength: 2
			}
		},
		messages: {
			'name': {
				required: 'Please enter your name.',
				minlength: 'Your name must be at least 2 characters long.'
			},
			'email': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			},
			'subject': {
				required: 'Please choose a subject.'
			},
			'facility': {
				required: 'Please choose a garage.'
			},
			'message': {
				required: 'Please explain how we can help you.',
				minlength: 'Your message must be at least 2 characters long.'
			}
		},
		submitHandler: function(form) {
			
			$('.button-spinner').prop('disabled', true);
			
			var name = $('#name').val();
			var email = $('#email').val();
			var subject = $('#subject').val();
			var facility = $('#facility').val();
			var message = $('#message').val();
			var nonce = $('#lm-contact-form-nonce').val();
			
			$.ajax({
				type: 'post',
				url: '/wp-admin/admin-ajax.php',
				data: {
					action: 'lm_contact_form',
					name: name,
					email: email,
					subject: subject,
					facility: facility,
					message: message,
					nonce: nonce
				},
				success: function(results) {
					var results = JSON.parse(results);
					console.log(results);
					if (results.status === 'success') {
						// it worked!
						$('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
					} else if (results.status === 'error') {
						// it didn't work?
						$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
					} else {
						// something else happened
						$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong? Please try again.');
					}
					$('.button-spinner').prop('disabled', false);
				},
				error: function(results) {
					var results = JSON.parse(results);
					console.log(results);
					$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong? Please try again.');
					$('.button-spinner').prop('disabled', false);
				}
			});
		}
	});

	// team member modals
	$('.lm-team-member a').on('click', function(e) {
		e.preventDefault();
		
		// get the selected team member's id
		var id = $(this).attr('data-id');
		
		$.ajax({
			type: 'post',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'lm_team_member_modal',
				id: id
			},
			success: function(results) {
				var results = JSON.parse(results);
				console.log(results);
				if (results.status === 'success') {
					// it worked!	
					var template = $($('#lm-team-member-modal').html());
					if (results.biography) {
						$('.lm-modal-content', template).append(results.biography);
					} else {
						$('.lm-modal-content', template).hide();
					}
					if (results.email_address || results.job_title) {
						if (results.email_address) {
							$('.lm-modal-email-address', template).append('<a href="' + results.email_address + '" title="Email ' + results.name + '">' + results.email_address + '</a>');
						} else {
							$('.lm-modal-email-address', template).hide();
						}
						if (results.job_title) {
							$('.lm-modal-job-title', template).append(results.job_title);
						} else {
							$('.lm-modal-job-title', template).hide();
						}
					} else {
						$('.lm-modal-header-text').hide();
					}
					if (results.name) {
						$('.lm-modal-header-title', template).append(results.name);
					} else {
						$('.lm-modal-header-title', template).hide();
					}
					if (results.photo) {
						$('.lm-modal-image', template).append('<img src="' + results.photo.url + '" alt="' + results.photo.alt + '" />');
					} else {
						$('.lm-modal-image', template).hide();
					}
					console.log(template);
					$('body').addClass('lm-modal-active').append(template);
				} else if (results.status === 'error') {
					// it didn't work!
				} else {
					// something else happened?
				}
			},
			error: function(results) {
				var results = JSON.parse(results);
				console.log(results);
				// ajax failed?!
			}
		});
	});
	
	// close team member modal
	$('body').on('click', '.lm-modal-close', function() {
		$('body').removeClass('lm-modal-active');
		$(this).parents('.lm-modal').remove();
	});

	// newsletter signup form
	$('#lm-newsletter-form').validate({
		errorElement: 'span',
		errorClass: 'form-field-error',
		validClass: 'form-field-valid',
		errorPlacement: function (error, element) {
			error.appendTo(element.parent('.lm-newsletter-form-fields'));
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parent('.lm-newsletter-form-fields').addClass(errorClass).removeClass(validClass);
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parent('.lm-newsletter-form-fields').removeClass(errorClass).addClass(validClass);
		},
		rules: {
			'lm-newsletter-email': {
				required: true,
				email: true
			}
		},
		messages: {
			'lm-newsletter-email': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			}
		},
		submitHandler: function(form) {
			
			console.log('hello!');
			
			// disable submit form
			$('.button-spinner', form).prop('disabled', true);
			
			// get variables
			var email = $('#lm-newsletter-email').val();
			var nonce = $('#lm-newsletter-form-nonce').val();
		
			// send 'em to campaign monitor!
			$.ajax({
				type: 'post',
				url: '/wp-admin/admin-ajax.php',
				data: {
					action: 'lm_newsletter_subscribe',
					email: email,
					nonce: nonce
				},
				success: function(results) {
					var results = JSON.parse(results);
					console.log('success!', results);
					$('.lm-newsletter-form-message', form).removeClass('lm-newsletter-form-message-error').addClass('lm-newsletter-form-message-success').text(results.message);
					$('.button-spinner', form).prop('disabled', false);
				},
				error: function(results) {
					var results = JSON.parse(results);
					console.log('error!', results);
					$('.lm-newsletter-form-message', form).removeClass('lm-newsletter-form-message-success').addClass('lm-newsletter-form-message-error').text(results.message);
					$('.button-spinner', form).prop('disabled', false);
				}
			});
			
		}
	});

});
